import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const DELETE_FILES_TRANSPORT_RESET = 'DELETE_FILES_TRANSPORT_RESET';
export const DELETE_FILES_TRANSPORT_LOADING = 'DELETE_FILES_TRANSPORT_LOADING';
export const DELETE_FILES_TRANSPORT_SUCCESS = 'DELETE_FILES_TRANSPORT_SUCCESS';
export const DELETE_FILES_TRANSPORT_REJECT = 'DELETE_FILES_TRANSPORT_REJECT';

//* ACTIONS ------------------------------------------------
export const deleteFilesTransportReset = () => ({ type: DELETE_FILES_TRANSPORT_RESET });
export const deleteFilesTransportLoading = () => ({ type: DELETE_FILES_TRANSPORT_LOADING });
export const deleteFilesTransportSuccess = (payload) => ({ type: DELETE_FILES_TRANSPORT_SUCCESS, payload });
export const deleteFilesTransportReject = (payload) => ({ type: DELETE_FILES_TRANSPORT_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const deleteFilesTransportRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.DELETE,
        data,
    }, getState);
    return request(`/Providers/web/DeleteProviderTransportUploadFile/${data}`, options);
};